<template>
  <main>
    <div class="searchs">
      <!-- 搜索组件 -->
      <search class="search" :noAnimation="true" @change="changeKeyword" />
    </div>
    <div class="banner">

      <div class="country">
        <ul class="options">
          <li v-for="(v, i) in countryDataList" :key="i" @mouseenter="changeArea(i)">
            <h4>{{ v.text }}</h4>
            <nav>
              <template v-for="(sub, idx) in v.countrys">
                <a @click="goList(sub)" :class="{ hot: sub.is_hot === 0 }" :key="idx" v-if="idx < 5">{{ sub.Name }}</a>
              </template>
            </nav>
          </li>
        </ul>
        <dl class="cont" v-if="countryIndex !== null">
          <dt>{{ countryDataList[countryIndex].text }}</dt>
          <dd v-for="(v, i) in countryDataList[countryIndex].countrys" :key="i" :class="{ hot: v.is_hot === 0 }"
            @click="goList(v)">
            {{ v.Name }}</dd>
        </dl>
      </div>


      <el-carousel class="ad">
        <el-carousel-item v-for="(v, i) in banner" :key="i">
          <router-link :to="v.url"><img :src="v.img" alt=""></router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
    <section class="recommend">
      <h2>热门签证</h2>
      <nav>
        <a :class="{ on: hotVisaIndex === i }" v-for="(v, i) in countryDataList" :key="v.id"
          @click="hotVisaIndex = i">{{
            v.text
          }}</a>
      </nav>
      <ul>
        <template>
          <li v-for="v in getHotVisa" :key="v.VisaCountryID">
            <router-link :to="{ path: './visa_list', query: { id: v.VisaCountryID, name: v.Name } }">
              <div class="imgWrapper"> <img :src="v.wechat_img" :alt="v.Name" /></div>
              <figure>
                <p>{{ v.Name }}</p>
                <b>{{ setNormalPrice(v.starting_dealer_price) || setNormalPrice(v.starting_price) }}</b>
              </figure>
            </router-link>
          </li>
        </template>
      </ul>
    </section>

    <!-- <div class="idPhotoEntrance">
      <div @click="openPhotoClipper" class="entranceText">证件照</div>
      <PhotoClipper ref="PhotoClipper" />
    </div> -->


    <section class="issue">
      <h2>常见问题 <router-link :to="{ name: 'faq' }">更多</router-link></h2>
      <ul>
        <router-link v-for="(v, i) in visaFAQ" :key="i" :to="{ name: 'faq_detail', query: { id: v.CommonFaqID } }"
          tag="li">
          <figure><b>{{ v.QTitle }}</b><i class=""></i></figure>
          <div class="cont" v-html="v.AText"></div>
        </router-link>
      </ul>
    </section>



    <!-- <el-dialog
      width="40%"
      title="网站平台升级更新通知！"
      class="hint"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="hint">
        <b>因网站平台能力更新升级，有部分变更，特此通知如下：</b>
        <p>1.老用户（登记手机号码的用户），需重新使用手机及验证码进行<router-link :to="{name: 'register'}">注册</router-link>验证；</p>
        <p>2.已注册的手机号，可以通过<router-link :to="{name: 'update_pwd'}">忘记密码</router-link>进行找回密码；</p>
        <p>3.历史订单查询，请使用<a target="_blank" href="http://old.cstravel.cn/">旧平台(http://old.cstravel.cn/)</a>访问。（<span class="warn">备注：不要在旧平台下单</span>）</p>
        <p>4.新平台钱包功能暂未开放，旧平台钱包余额只支持人工处理或联系跟单销售！（<span class="warn">服务电话：0755-22658484</span>）</p>
      </el-dialog> -->
  </main>
</template>

<script>
import $visa from '@api/visa';
import search from '@components/search';
import tool from '@assets/js/tool';
import PhotoClipper from '@components/PhotoClipper';
export default {
  components: {
    search,
    PhotoClipper
  },
  data() {
    return {
      hint: true,
      banner: [],
      hot: [],
      hotVisaIndex: 0,
      country: [],
      countryIndex: null,
      visaFAQ: [],
      countryDataList: []
    }
  },
  computed: {
    getHotVisa() {
      let _this = this;
      if (_this.countryDataList && _this.countryDataList.length) {
        return _this.countryDataList[_this.hotVisaIndex]['countrys'];
      }
    },
    swiper() {
      return this.$refs.swiper.$swiper
    }
  },
  created() {
    this.getData();
    this.getAd();
  },
  methods: {
    openPhotoClipper() {
      this.$refs.PhotoClipper.openWrap();
    },
    // 显示正常价格
    setNormalPrice(price) {
      return tool.ConversionPrice(price)
    },
    // 签证列表
    goList(item) {
      const { VisaCountryID: id, Name: name, } = item;
      this.$router.push({ name: 'visa_list', query: { id, name } });
    },
    changeKeyword({ id }) {
      this.$router.push({ name: 'visa_list', query: { id, name } });
    },
    // 请求列表数据
    getList(id) {
      this.loading = true;
      this.$axios.get(`/VisaProduct/byCountry/${id}`).then(({ products }) => {
      }).catch(err => {
        this.$message.warning('请求数据失败，请稍后再试！');
        this.loading = false;
      })
    },
    async getAd() {
      const { banners } = await $visa.getAd();
      this.banner = banners;
    },
    getData() {
      $visa.getCountry().then(res => {
        const { banner, countryData, visaFAQ } = res;
        // 获取热门签证
        const hots = countryData.reduce((arr, v) => {
          let hot = v.country.filter(sub => sub.is_hot === 0);
          hot = hot.map(sub => {
            sub.parentId = v.id;
            return sub;
          });
          return [...arr, ...hot];
        }, []);
        // this.banner = banner;
        this.hot = hots;
        this.country = countryData;
        this.visaFAQ = visaFAQ.data.map(v => {
          let str = v.AText.replace(`<br />`, '');
          return { ...v, AText: str }
        });
      })

      // 获取新的签证列表
      $visa.getHomeVisaProductList().then((res) => {
        let data = res.data;

        // 将第一项的热门,添加 热门类名
        data[0]['countrys'].map((item) => {
          item.is_hot = 0;
        });

        const hotCountryIdList = data[0]['countrys'].map((item) => { return item.VisaCountryID }); //热们国家ID
        data.map((item, index) => {
          // 排除第一项
          if (index >= 1) {
            item.countrys.map((item2) => {
              if (hotCountryIdList.includes(item2.VisaCountryID)) {
                item2.is_hot = 0;
              }
            })
          }
        });

        this.countryDataList = data;
      });

    },
    slideDirection(attr) {
      this.swiper[attr]();
    },
    changeArea(index) {
      this.countryIndex = index;
    }
  }
}
</script>

<style scoped src="./index.css"></style>
<style>
.el-carousel__container {
  height: 460px;
}

@media only screen and (max-width: 1200px) {

  .banner {

    .ad {
      .el-carousel__container {
        height: 400px;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {

  .banner {

    .ad {
      .el-carousel__container {
        height: 300px;
      }

    }
  }
}
</style>
